import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "share-coach-actions" }
const _hoisted_2 = {
  key: 1,
  class: "share-coach-optout"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiShareGuide = _resolveComponent("AiShareGuide")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "share-coach-backdrop",
      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", {
        class: "share-coach",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "share-coach-title",
        "aria-describedby": "share-coach-text",
        onKeydown: [
          _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]), ["esc"])),
          _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.trapTab && _ctx.trapTab(...args)), ["tab"]))
        ]
      }, [
        (_ctx.mode === 'help')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "share-coach-x",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×"))
          : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createElementVNode("h2", { id: "share-coach-title" }, "Record everyone on the call", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { id: "share-coach-text" }, [
          _createTextVNode("Chrome will ask what to share. Turn on "),
          _createElementVNode("strong", null, "Share with system audio"),
          _createTextVNode(" or people on the call won’t be recorded.")
        ], -1)),
        _createVNode(_component_AiShareGuide, { class: "share-coach-guide" }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            ref: "primary",
            type: "button",
            class: "share-coach-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, _toDisplayString(_ctx.mode === 'start' ? 'Got it — open the picker' : 'Got it'), 513),
          (_ctx.mode === 'start')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "share-coach-cancel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
              }, "Cancel"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.mode === 'start')
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dontShow) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.dontShow]
              ]),
              _cache[7] || (_cache[7] = _createTextVNode("Don’t show this again", -1))
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}